import { create } from 'zustand';

export type AppStatus = 'idle' | 'game' | 'race' | 'waitingForResult';
export type GameOverReason = 'timeout' | 'success' | 'tapNotSuccess' | 'technical' | 'raceWin';

interface AppStore {
	appStatus: AppStatus;
	gameOverReason: GameOverReason | null;
	isBannerClosed: boolean;
	setAppStatus: (status: AppStatus) => void;
	setGameOverReason: (reason: GameOverReason | null) => void;
	setIsBannerClosed: (value: boolean) => void;
}

export const useAppStore = create<AppStore>((set) => ({
	appStatus: 'idle',
	gameOverReason: null,
	isBannerClosed: false,
	isSoundEnabled: true,
	setAppStatus: (status) => set({ appStatus: status }),
	setGameOverReason: (reason) => set({ gameOverReason: reason }),
	setIsBannerClosed: (value) => set({ isBannerClosed: value }),
}));
